import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Heading from "../Heading/Heading";
import "./Create New Account.css";
//import { Card, Form } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createNewAccountAPI, checkExistingAccount } from "../../api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import ConfirmationModal from "../Confirmation Modal/ConfirmationModal";
// import { Modal, Button } from "react-bootstrap";
import Loader from "../Loader/Loader";

// Correct imports from react-google-recaptcha-v3
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { Button, Modal } from "react-bootstrap";

const CreateNewAccountContent = () => {
  const navigate = useNavigate();

  // State variables
  const [selectedOption, setSelectedOption] = useState("Agent");
  const [accountType, setAccountType] = useState("Agent");
  const [maraAgent, setMaraAgent] = useState("yes");
  const [termsChecked, setTermsChecked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [marn, setMarn] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showConfirmationSuccessModal, setShowConfirmationSuccessModal] = useState(false);
  const [accountCreatedSuccessfully, setAccountCreatedSuccessfully] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Use reCAPTCHA hook
  const { executeRecaptcha } = useGoogleReCaptcha();

  // Handle successful account creation
  const handleSuccessful = () => {
    setAccountCreatedSuccessfully(true);
    setShowConfirmationSuccessModal(true);
  };

  const handleConfirmationAccountCreatedNo = () => {
    setShowConfirmationSuccessModal(false);
  };

  const handleConfirmationAccountCreatedYes = () => {
    setShowConfirmationSuccessModal(false);
    navigate("/");
    setAccountCreatedSuccessfully(false);
    toast.success("Account created successfully, kindly check your nominated email.");
  };

  const handleConfirmationNo = () => {
    setShowConfirmationModal(false);
  };

  const handleConfirmationYes = () => {
    navigate("/");
    setShowConfirmationModal(false);
  };

  // Email validation
  const handleEmailChange = async (event) => {
    const input = event.target.value;
    setEmail(input);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(input)) {
      setEmailError("Please enter a valid email address.");
    } else {
      const data = await checkExistingEmail(input);
      if (data?.response === true) {
        setEmailError("This email is already registered. Please use a different email.");
      } else {
        setEmailError("");
      }
    }
  };

  const checkExistingEmail = async (email) => {
    const formData = new FormData();
    formData.append("email", email);
    try {
      const response = await checkExistingAccount(formData);
      return response.data.response;
    } catch (error) {
      console.error("Error checking existing email:", error);
      return false;
    }
  };

  // Password validation
  const handlePasswordChange = (event) => {
    const input = event.target.value;
    setPassword(input);

    const hasUpperCase = /[A-Z]/.test(input);
    const hasLowerCase = /[a-z]/.test(input);
    const hasNumber = /\d/.test(input);
    const hasSymbol = /[$&+,:;=?@#|'<>.^*()%!-]/.test(input);
    const isLengthValid = input.length >= 8 && input.length <= 20;

    if (isLengthValid && hasUpperCase && hasLowerCase && hasNumber && hasSymbol) {
      setPasswordError("");
    } else {
      setPasswordError(
        "Password must be 8-20 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one symbol."
      );
    }
  };

  const handleConfirmPasswordChange = (event) => {
    const input = event.target.value;
    setConfirmPassword(input);
    if (input !== password) {
      setConfirmPasswordError("Passwords do not match.");
    } else {
      setConfirmPasswordError("");
    }
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setAccountType(event.target.value);
    if(event.target.value == "Applicant"){
      setBusinessName("");
      setMaraAgent("no");
      setMarn(""); 
    }
    
  };

  // Submit handler with reCAPTCHA v3
  const handleSubmit = async (event) => {
    event.preventDefault();

    // Run all client-side validations first
    if (email.trim() === "") {
      toast.error("Please enter your email.");
      document.getElementById("email").focus();
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email.trim())) {
      toast.error("Please enter a valid email address.");
      document.getElementById("email").focus();
      return;
    }

    if (password.trim() === "") {
      toast.error("Please enter your password.");
      document.getElementById("password").focus();
      return;
    }

    if (passwordError) {
      toast.error(
        "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one number, and one symbol."
      );
      document.getElementById("password").focus();
      return;
    }

    if (confirmPassword.trim() === "") {
      toast.error("Please confirm your password.");
      document.getElementById("confirmPassword").focus();
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords do not match.");
      setConfirmPasswordError("Passwords do not match.");
      document.getElementById("confirmPassword").focus();
      return;
    }

    if (accountType === "Agent") {
      if (firstName.trim() === "") {
        toast.error("Please enter your first name.");
        document.getElementById("firstName").focus();
        return;
      }
      if (surname.trim() === "") {
        toast.error("Please enter your surname.");
        document.getElementById("surname").focus();
        return;
      }
      if (businessName.trim() === "") {
        toast.error("Please enter your business name.");
        document.getElementById("businessName").focus();
        return;
      }
      if (maraAgent === "yes" && marn.trim() === "") {
        toast.error("Please enter your MARN number.");
        document.getElementById("marn").focus();
        return;
      }
    } else if (accountType === "Applicant") {
      if (firstName.trim() === "") {
        toast.error("Please enter your first name.");
        document.getElementById("firstName").focus();
        return;
      }
      if (surname.trim() === "") {
        toast.error("Please enter your surname.");
        document.getElementById("surname").focus();
        return;
      }
    }

    if (!termsChecked) {
      toast.error("Please agree to the terms and conditions.");
      document.getElementById("termsAndConditions").focus();
      return;
    }

    // ✅ Execute reCAPTCHA only if available
    if (!executeRecaptcha) {
      toast.error("reCAPTCHA is not ready yet. Please try again.");
      return;
    }

    try {
      setIsLoading(true);

      // Get reCAPTCHA token
      const token = await executeRecaptcha("submit");

      if (!token) {
        toast.error("Captcha verification failed. Please try again.");
        setIsLoading(false);
        return;
      }

      // All validations passed — proceed to API call
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      formData.append("cpassword", confirmPassword);
      formData.append("migration-number", maraAgent === "yes" ? marn : "");
      formData.append("business-name", businessName);
      formData.append("given-name", firstName);
      formData.append("surname", surname);
      formData.append("account_type", accountType);
      formData.append("are_u_mara_agent", maraAgent);
      formData.append("g-recaptcha-response", token);

      const response = await createNewAccountAPI(formData);
      setIsLoading(false);

      const responseData = response.data.response;
      if (responseData && responseData.response === true) {
        handleSuccessful();
      } else {
        const errorMsg = responseData?.error_msg || "An error occurred. Please try again.";
        toast.error(errorMsg);
      }
    } catch (error) {
      setIsLoading(false);
      toast.error("An error occurred during registration. Please try again.");
      console.error("Registration error:", error);
    }
  };

  return (
    <>
      <Heading text="Welcome to the Skills Assessment Online Portal" />
      <div className="d-flex justify-content-center align-items-center h-100% ">
        <div style={{ width: "576px" }}>
          <div className="container-fluid">
            <div className="row justify-content-center mt-4">
              <div className="col-md-12">
                {/* Account Type */}
                <div className="form-group mt-4 mb-3">
                  <h3>
                    <b>Create an account</b>
                  </h3>

                </div>

                {/* Account Type */}
                <div className="form-group mb-3">
                  <label htmlFor="accountType" className="form-label label-font-size label-font-size">
                    <b>Account Type<span className="text-danger">*</span></b>
                  </label>
                  <select
                    id="accountType"
                    className="form-select"
                    value={selectedOption}
                    onChange={handleOptionChange}
                  >
                  
                    <option value="Agent">Agent</option>
                    <option value="Applicant">Applicant</option>
                  </select>

                </div>

                {/* Email Address */}
                <div className="form-group mb-3">
                  <label htmlFor="email" className="form-label label-font-size label-font-size">
                    <b>Email address<span className="text-danger">*</span></b>
                  </label>
                  <input
                    type="email"
                    className={`form-control ${emailError ? "is-invalid" : ""}`}
                    id="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={email}
                    onChange={handleEmailChange}
                    aria-describedby="emailError"
                    style={{ height: "auto" }}
                  />
                  {emailError && (
                    <div id="emailError" className="invalid-feedback">
                      {emailError}
                    </div>
                  )}
                </div>


                {/* Password & Confirm Password */}
           <div className="row g-3">
  {/* Password */}
  <div className="col-md-6">
    <div className="form-group" style={{ position: "relative" }}>
      <label htmlFor="password" className="form-label label-font-size">
        <b>Password<span className="text-danger">*</span></b>
      </label>

      {/* Input with icon inside */}
      <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
        <input
          type={showPassword ? "text" : "password"}
          className={`form-control ${passwordError ? "is-invalid" : ""}`}
          id="password"
          name="password"
          placeholder="Enter your password"
          value={password}
          onChange={handlePasswordChange}
          aria-describedby="passwordError"
          style={{
            height: "40px",
            paddingRight: "40px", // Make room for the icon
            boxSizing: "border-box",
          }}
        />

        {/* Eye Icon - Positioned INSIDE the input */}
        <span
          onClick={() => setShowPassword(!showPassword)}
          style={{
            position: "absolute",
            top: "49%",
            right: passwordError ? "33px" : "12px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6c757d",
            zIndex: 2,
          }}
        >
          {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </span>
      </div>

      {/* Error Message */}
      {passwordError && (
        <div id="passwordError" className="invalid-feedback d-block">
          {passwordError}
        </div>
      )}
    </div>
  </div>

  {/* Confirm Password */}
  <div className="col-md-6">
    <div className="form-group" style={{ position: "relative" }}>
      <label htmlFor="confirmPassword" className="form-label label-font-size">
        <b>Confirm Password<span className="text-danger">*</span></b>
      </label>

      {/* Input with icon inside */}
      <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
        <input
          type={showConfirmPassword ? "text" : "password"}
          className={`form-control ${confirmPasswordError ? "is-invalid" : ""}`}
          id="confirmPassword"
          name="confirmPassword"
          placeholder="Confirm your password"
          value={confirmPassword}
          onChange={handleConfirmPasswordChange}
          aria-describedby="confirmPasswordError"
          style={{
            height: "40px",
            paddingRight: "40px",
            boxSizing: "border-box",
          }}
        />

        {/* Eye Icon - Positioned INSIDE the input */}
        <span
          onClick={toggleConfirmPasswordVisibility}
          style={{
            position: "absolute",
            top: "49%",
            right: confirmPasswordError ? "33px" : "12px",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6c757d",
            zIndex: 2,
          }}
        >
          {showConfirmPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </span>
      </div>

      {/* Error Message */}
      {confirmPasswordError && (
        <div id="confirmPasswordError" className="invalid-feedback d-block">
          {confirmPasswordError}
        </div>
      )}
    </div>
  </div>
</div>


<div className="row mb-3">
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="firstName" className="form-label label-font-size">
                            <b>First Name<span className="text-danger">*</span></b>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="firstName"
                            name="firstName"
                            placeholder="Enter your first name"
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                            style={{ height: "40px" }}
                            aria-describedby="firstNameError"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <label htmlFor="surname" className="form-label label-font-size">
                            <b>Last Name<span className="text-danger">*</span></b>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="surname"
                            name="surname"
                            placeholder="Enter your surname"
                            value={surname}
                            onChange={(e) => setSurname(e.target.value)}
                            style={{ height: "40px" }}
                            aria-describedby="surnameError"
                          />
                        </div>
                      </div>
                    </div>




                {/* Agent Details */}
                {accountType === "Agent" && (
                  <>

                    <div className="form-group mb-3">
                      <label htmlFor="businessName" className="form-label label-font-size">
                        <b>Business Name<span className="text-danger">*</span></b>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="businessName"
                        name="businessName"
                        placeholder="Enter your business name"
                        value={businessName}
                        onChange={(e) => setBusinessName(e.target.value)}
                        style={{ height: "40px" }}
                        aria-describedby="businessNameError"
                      />
                    </div>

                    <div className="form-group mb-3 d-flex flex-column">
                      <label className="form-label label-font-size">
                        <b>Are you a MARA Agent?<span className="text-danger">*</span></b>
                      </label>
                      <div>
                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="maraAgent"
                            value="yes"
                            checked={maraAgent === "yes"}
                            onChange={() => setMaraAgent("yes")}
                            style={{
                              marginRight: "5px",
                              border: "2px solid #ccc",
                              borderRadius: "50%",
                              width: "22px",
                              height: "22px",
                              cursor: "pointer",
                            }}
                          />
                          <label className="form-check-label label-font-size">Yes</label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            type="radio"
                            className="form-check-input"
                            name="maraAgent"
                            value="no"
                            checked={maraAgent === "no"}
                            onChange={() => setMaraAgent("no")}
                            style={{
                              marginRight: "5px",
                              border: "2px solid #ccc",
                              borderRadius: "50%",
                              width: "22px",
                              height: "22px",
                              cursor: "pointer",
                            }}
                          />
                          <label className="form-check-label label-font-size">No</label>
                        </div>
                      </div>
                    </div>

                    {maraAgent === "yes" && (
                      <div className="form-group mb-3">
                        <label htmlFor="marn" className="form-label label-font-size">
                          <b>Migration Agent Registration Number (MARN)<span className="text-danger">*</span></b>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="marn"
                          name="marn"
                          placeholder="Enter your MARN"
                          value={marn}
                          onChange={(e) => setMarn(e.target.value)}
                          style={{ height: "40px" }}
                          aria-describedby="marnError"
                        />
                      </div>
                    )}
                  </>
                )}

                {/* Cookies Notice */}
                <div className="mt-4 label-font-size">
                  <h5 className="mb-2" style={{ fontSize: "16px" }}>
                    <b>Cookies Notice</b>
                  </h5>
                  <p style={{ fontSize: "14px", lineHeight: "1.5" }}>
                    Cookies are used on this website so that we can monitor how many people visit it, what pages they view, and how long they spend on each page. This data enables us to make sure we are fulfilling our top priority of informing you and to continuously enhance the service we provide to website visitors. Learn more about our <a href="https://aqato.com.au/privacy-policy/" className="text-decoration-underline" target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
                  </p>
                </div>

                {/* Terms and Conditions */}
                <div className="mt-4">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="termsAndConditions"
                      name="termsAndConditions"
                      checked={termsChecked}
                      onChange={() => setTermsChecked(!termsChecked)}
                      style={{ border: "1px solid #055837" }}
                    />
                    <label className="form-check-label" htmlFor="termsAndConditions" style={{ fontSize: "14px" }}>
                      I accept the <a href="https://aqato.com.au/terms-and-conditions/" className="text-decoration-underline" target="_blank" rel="noopener noreferrer">Terms and Conditions</a> and confirm that I have read the <a href="https://aqato.com.au/privacy-policy/" className="text-decoration-underline" target="_blank" rel="noopener noreferrer">Privacy Policy.</a>
                    </label>
                  </div>
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mt-4">

                  <button
                    type="button"
                    className="btn"
                    style={{
                      // backgroundColor: "#5b5a57ff",
                      // color: "#055837",
                      borderRadius: "5px",
                      padding: "10px 20px",
                      transition: "all 0.3s",
                      border: "1px #5b5a57ff solid",
                      flex: 1,
                    }}
                    onClick={() => setShowConfirmationModal(true)}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn"
                    style={{
                      backgroundColor: "#055837",
                      color: "#ffcc01",
                      border: "none",
                      borderRadius: "5px",
                      padding: "10px 20px",
                      transition: "all 0.3s",
                      flex: 1,
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "#ffcc01";
                      e.target.style.color = "#055837";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#055837";
                      e.target.style.color = "#ffcc01";
                    }}
                    disabled={isLoading}
                    onClick={handleSubmit}
                  >
                    {isLoading ? <Loader /> : "Create an account"}{" "}
                    <span>
                      <i className="bi bi-arrow-right"></i>
                    </span>
                  </button>
                </div>

                <ConfirmationModal
                  show={showConfirmationModal}
                  onHide={handleConfirmationNo}
                  onConfirm={handleConfirmationYes}
                  title="Confirm Logout"
                  message="Are you sure you want to cancel creating a new account? Any information entered will be lost."
                />

                {/* Login Link */}
                <div className="mt-3 mb-4" style={{ height: "110px", fontSize: "16px" }}>
                  <p>
                    Already have an account?{" "}
                    <a
                      onClick={() => navigate("/")}
                      style={{
                        // fontWeight: "semi-bold",
                        textDecorationLine: "underline",
                        color: "black",
                        cursor: "pointer",
                      }}
                    >
                      Login
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



      <ConfirmationModal
        show={showConfirmationModal}
        onHide={handleConfirmationNo}
        onConfirm={handleConfirmationYes}
        title="Confirm Logout"
        message="Are you sure you want to cancel creating a new account? Any information entered will be lost."
      />

      {accountCreatedSuccessfully && (
        <Modal show={showConfirmationSuccessModal} centered>
          <Modal.Header>
            <Modal.Title
              className="text-center w-100"
              style={{
                fontSize: "18px",
                fontFamily: "Arial, sans-serif",
                color: "#055837",
              }}
            >
              Account Created Successfully !
            </Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="text-left"
            style={{ fontSize: "16px", fontFamily: "Arial, sans-serif" }}
          >
            <ul style={{ listStyle: "none", paddingLeft: "0" }}>
              <li style={{ marginBottom: "10px" }}>
                <span style={{ color: "black" }}>•</span> Thank you{" "}
                <strong>{firstName}</strong>, for creating an account.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <span style={{ color: "black" }}>•</span> An email has been
                sent to your nominated email address (
                <strong>{email}</strong>) with your account activation link.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <span style={{ color: "black" }}>•</span> Please check your
                Inbox/Junk Mail and follow the link to activate your
                account.
              </li>
              <li style={{ marginBottom: "10px" }}>
                <span style={{ color: "black" }}>•</span> If you do not
                receive a notification email from us within the next 15
                minutes, please contact us at{" "}
                <a href="mailto:skills@aqato.com.au">skills@aqato.com.au</a>{" "}
                for assistance.
              </li>
            </ul>
          </Modal.Body>

          <Modal.Footer className="d-flex justify-content-center">
            <Button
              variant="light"
              onClick={handleConfirmationAccountCreatedYes}
              className="w-50"
              style={{
                maxWidth: "130px",
                backgroundColor: "#055837",
                color: "#ffcc01",
                transition: "transform 0.2s",
              }}
              onMouseEnter={(e) =>
                (e.target.style.transform = "scale(1.02)")
              }
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              Okay
            </Button>
          </Modal.Footer>
        </Modal>
      )}


    </>
  );
};

// Main Component with reCAPTCHA Provider
const CreateNewAccount = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      <CreateNewAccountContent />
    </GoogleReCaptchaProvider>
  );
};

export default CreateNewAccount;